import { Injectable } from '@angular/core';

import { Actions, createEffect, ofType, OnInitEffects } from '@ngrx/effects';

import { filter, map } from 'rxjs/operators';

import { Action } from '@ngrx/store';
import { TRAVEL_BOOKING_PROGRESS_BAR_LOCAL_STORAGE_KEY } from 'app.config';
import * as travelBookingBarActions from '../actions/travel-booking-progress-bar.actions';
import * as travelBookingBarReducers from '../reducers/travel-booking-progress-bar.reducers';

@Injectable()
export class TravelBookingProgressBarEffects implements OnInitEffects {
  constructor(private actions$: Actions) {}

  public ngrxOnInitEffects(): Action {
    return new travelBookingBarActions.RestoreTravelBookingBar();
  }

  public restoreTravelBookingBar$ = createEffect(() =>
    this.actions$.pipe(
      ofType(travelBookingBarActions.RESTORE_TRAVEL_BOOKING_BAR),
      map(() => localStorage.getItem(TRAVEL_BOOKING_PROGRESS_BAR_LOCAL_STORAGE_KEY)),
      filter((localStorageItem) => !!localStorageItem),
      map(
        (localStorageItem) => new travelBookingBarActions.RestoreTravelBookingBarSuccess(JSON.parse(localStorageItem))
      )
    )
  );

  public clearTravelBookingBar$ = createEffect(() =>
    this.actions$.pipe(
      ofType(travelBookingBarActions.CLEAR_TRAVEL_BOOKING_BAR),
      map(() => {
        this.setLocalStorage(travelBookingBarReducers.initialState);
        return new travelBookingBarActions.ClearTravelBookingBarSuccess();
      })
    )
  );

  public updateTravelBookingBar$ = createEffect(() =>
    this.actions$.pipe(
      ofType(travelBookingBarActions.UPDATE_TRAVEL_BOOKING_BAR),
      map((action: travelBookingBarActions.UpdateTravelBookingBar) => {
        this.setLocalStorage(action.payload);
        return new travelBookingBarActions.UpdateTravelBookingBarSuccess(action.payload);
      })
    )
  );

  /**
   * Sets the local storage item for the travel booking progress bar
   *
   * @param json
   */
  public setLocalStorage(data: any) {
    const existingValue = localStorage.getItem(TRAVEL_BOOKING_PROGRESS_BAR_LOCAL_STORAGE_KEY);
    if (existingValue !== null) {
      data = {
        ...JSON.parse(existingValue),
        ...data,
      };
    } else {
      data = {
        ...travelBookingBarReducers.initialState,
        ...data,
      };
    }
    localStorage.setItem(TRAVEL_BOOKING_PROGRESS_BAR_LOCAL_STORAGE_KEY, JSON.stringify(data));
  }
}
